import { ShopService } from 'src/app/data/repository/shop-repository/shop.service';
import { BottomsheetShared } from './../../general/shared/bottomsheet-shared';
import { GenerateShared } from './../../general/shared/generate-shared';
import { PlanShared } from 'src/app/presentation/general/shared/plan-shared';
import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { PlanService } from 'src/app/data/repository/plan-repository/plan.service';
import { ActivatedRoute } from '@angular/router';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import { SubmitButtonShared } from '../../general/shared/submit-button-shared';
import { Subscription } from 'rxjs';
import { IosBottomsheetInputModel } from '../../general/ios-bottomsheet/ios-bottomsheet.component';

@Component({
  selector: 'app-cheat-day',
  templateUrl: './cheat-day.component.html',
  styleUrls: ['./cheat-day.component.scss'],
})
export class CheatDayComponent implements OnInit, OnDestroy {
  dietId: string;
  day: string;
  isCheatDay = false;
  cheatDayCount: string;
  isCheatDayAcitve = true;
  isPredefined = false;
  dietType = '';

  planLock = false;

  iosBottomsheetInput: IosBottomsheetInputModel;
  showIosBottomsheet = false;

  SWIPE_ACTION = { RIGHT: 'swiperight', LEFT: 'swipeleft' };

  showLoading = false;

  subscription1: Subscription;

  constructor(
    private planService: PlanService,
    private route: ActivatedRoute,
    private snackBarService: SnackBarService,
    private submitButtonShared: SubmitButtonShared,
    private planShared: PlanShared,
    private shopService: ShopService
  ) {
    this.dietId = this.route.snapshot.paramMap.get('dietId');
    this.day = this.route.snapshot.paramMap.get('day');
    this.isCheatDay =
      this.route.snapshot.paramMap.get('isCheat') === '0' ? false : true;
    this.cheatDayCount = this.route.snapshot.paramMap.get('cheatDayCount');
    this.isPredefined =
      this.route.snapshot.paramMap.get('isPredefined') === '0' ? false : true;
    if (
      this.planShared.lockPlan === null ||
      this.planShared.lockPlan === undefined
    ) {
      this.closeCheatDay();
    }
    this.planLock = this.planShared.lockPlan;
    if (this.dietId === '1' || this.isPredefined || this.planLock) {
      this.submitButtonShared.activateNextButton(true);
    }
    if (this.dietId === '1' || this.dietId === '0') {
      this.isCheatDayAcitve = false;
    }
    if (this.isPredefined) {
      this.dietType = this.planShared.dietType.name;
    }
    this.subscription1 = this.submitButtonShared.nextButtonClickObs$.subscribe(
      (clicked) => {
        if (clicked) {
          if (this.planLock) {
            this.goToShop();
          } else {
            this.goToGenerate();
          }
        }
      }
    );
  }

  ngOnInit() {}

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription1.unsubscribe();
  }

  goToGenerate() {
    this.planService.goToGenerate();
  }

  goToShop() {
    this.shopService.goToShopPage('cheatDay');
  }

  swipe(action: string = this.SWIPE_ACTION.RIGHT) {
    if (action === this.SWIPE_ACTION.RIGHT && !this.isCheatDay) {
      this.showLoading = true;
      this.animateActivateCheatDay();
    }
    if (action === this.SWIPE_ACTION.LEFT && this.isCheatDay) {
      this.showLoading = true;
      this.animateDeactivateCheatDay();
    }
  }

  animateActivateCheatDay() {
    document.getElementById('cheat-day-submit-icon').style.right = '3px';
    setTimeout(() => {
      document.getElementById('cheat-day-submit-title').innerText = '';
    }, 100);
    setTimeout(() => {
      document.getElementById('cheat-day-submit-icon').style.width =
        'calc( 100% - 6px )';
    }, 180);
    setTimeout(() => {
      this.activateCheatDay();
    }, 380);
  }

  animateDeactivateCheatDay() {
    document.getElementById('cheat-day-submit-icon').style.right =
      'calc( 100% - 53px )';
    document.getElementById('cheat-day-submit-icon').style.width = '50px';
    document.getElementById('cheat-day-submit-title').innerText =
      'برای روز آزاد بکشید';
    setTimeout(() => {
      this.deactivateCheatDay();
    }, 200);
  }

  activateCheatDay() {
    console.log(this.day);

    this.planService
      .cheatDay(this.dietId, parseInt(this.day), true)
      .then((res) => {
        if (res.isSuccess()) {
          this.closeCheatDay();
        } else {
          this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          this.isCheatDay = true;
          this.isCheatDay = false;
        }
        this.showLoading = false;
      });
  }

  deactivateCheatDay() {
    this.planService
      .cheatDay(this.dietId, parseInt(this.day), false)
      .then((res) => {
        if (res.isSuccess()) {
          this.closeCheatDay();
        } else {
          this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          this.isCheatDay = false;
          this.isCheatDay = true;
        }
        this.showLoading = false;
      });
  }

  closeCheatDay() {
    this.planService.goBack();
  }
}
